import { useQuery } from '@apollo/client';

import { TimeRangeEnum } from '@libs/backend-common';

import { CurrencyType } from 'src/constants';
import { getAssetCmcInfoQuery } from 'src/gql';

import { useApiResponse } from './useApiResponse';

type UseAssetCmcInfoArgs = {
  code: CurrencyType;
  // valueAssetCode: CurrencyType;
  range: TimeRangeEnum;
};

export const useAssetCmcInfo = ({
  code,
  range,
}: // valueAssetCode,
UseAssetCmcInfoArgs) => {
  const res = useQuery(getAssetCmcInfoQuery, {
    variables: {
      record: {
        code,
      },
      changeRecord: {
        range,
        valueAssetCode: CurrencyType.USD,
      },
    },
  });

  const { response, loading } = useApiResponse(res);

  return {
    assetInfo: response?.getAssetCmCInfo,
    refetch: res.refetch,
    loading,
  };
};
